'use strict';
import $ from 'jquery';

export default class CustomerStoryDetail {
    static init() {
        $('.module-m107').each((index, el) => {
            new CustomerStoryDetail($(el));
        });
    }

    constructor($module) {
        this.module = $module;
        this.previousWindowWidth = $(window).outerWidth();
        $(window).on('resize', () => {
            if (this.previousWindowWidth < 768 && $(window).outerWidth() > 767) {
                this.init();
            } else if(this.previousWindowWidth < 1366 && $(window).outerWidth() > 1365) {
                this.init();
            } else if (this.previousWindowWidth > 767 && $(window).outerWidth() < 768) {
                // If switching from desktop to mobile, set the top of the cta box to auto so it doesn't overlap anything below it.
                this.sidebar.find('.module-m107-sidebar-items').css('max-height', 'none');
                this.ctaBox.css('top', 'auto');
            }
            this.previousWindowWidth = $(window).outerWidth();
        });
        if (this.module.find('.module-m107-sidebar-cta-box').length > 0 && $(window).outerWidth() > 767) {
            setTimeout(() => {
                this.init();
            }, 100);
        }
    }

    init() {
        this.sidebar = this.module.find('.module-m107-sidebar');
        let newSidebarTop = $('.siteHeader').outerHeight(true);
        if ($('#wpadminbar').length > 0)
            newSidebarTop += $('#wpadminbar').height();
        // console.log("setting sidebar css top: %d", newSidebarTop);
        this.sidebar.css('top', `${newSidebarTop}px`);
        this.sidebarTop = $('.siteHeader').outerHeight(true) + 30;
        this.sidebarOffsetTop = this.sidebar.offset().top;
        this.sidebarHeight = this.sidebar.height();

        this.ctaBox = this.module.find('.module-m107-sidebar-cta-box');
        console.log("setting ctabox top to %d in init()", newSidebarTop);
        this.ctaBox.css('top', `${newSidebarTop}px`);
        this.ctaBoxTop = $('.siteHeader').outerHeight(true) + 30;
        this.profileOffsetTop = this.sidebar.offset().top;
        this.ctaBoxOffsetTop = this.ctaBox.offset().top;

        $(document).on('scroll', this.onScroll.bind(this));

        $(window).on('resize', this.onResize.bind(this));
        this.onResize();
    }

    onResize() {
        this.ctaBoxOffsetTop = this.ctaBox.offset().top;
        if ($(window).outerWidth() > 767) {
            this.resizeSidebarItems();
            this.sidebarFade();
        }
        // console.log("window width: %d, ctaboxscrolledpast: %s", $(window).outerWidth(), this.ctaBoxScrolledPast());

        if (this.ctaBoxScrolledPast() && $(window).outerWidth() > 767) {
            this.sidebar.addClass('fade');
        } else if ($(window).outerWidth() < 768) {
            this.sidebar.removeClass('fade');
        }
    }
    // If the viewport height (minus the sticky header height) isn't enough to contain the entire sidebar, make the sidebar
    // ul items have to scroll vertically.
    /*
    *   when it works: 769 / 784
    * too short: setting max height: (window: 916) - (siteheader: 131) - (m107-sidebar: 752) - (m107-sidebar-items: 476) - (wpadminbar: 32) 476
    *
    */
    resizeSidebarItems() {
        let viewportHeight = $(window).outerHeight() - $('.siteHeader').outerHeight(true);
        if ($('#wpadminbar').length > 0)
            viewportHeight -= $('#wpadminbar').height();
        // console.log("sidebar height: %d, viewport height: %d", this.sidebarHeight, viewportHeight);

        if (this.sidebarHeight > viewportHeight) {
            if ($(document).scrollTop() + $('.siteHeader').outerHeight() > this.sidebarOffsetTop) {
                this.sidebar.find('.module-m107-sidebar-items').addClass('collapsible');
                let maxHeight = ($(window).height() - $('.siteHeader').height()) - ($('.module-m107-sidebar').height() - $('.module-m107-sidebar-items').height());
                if ($('#wpadminbar').length > 0)
                    maxHeight -= $('#wpadminbar').height();
                this.sidebar.find('.module-m107-sidebar-items').css('max-height', maxHeight);
            } else {
                this.sidebar.find('.module-m107-sidebar-items').removeClass('collapsible');
                this.sidebar.find('.module-m107-sidebar-items').css('max-height', 'none');

            }
        } else {
            this.sidebar.find('.module-m107-sidebar-items').removeClass('collapsible');
            this.sidebar.find('.module-m107-sidebar-items').css('max-height', 'none');
        }
    }

    ctaBoxScrolledPast() {
        let scrolledPast = $(document).scrollTop() + $('.siteHeader').outerHeight() > this.ctaBox.offset().top + this.ctaBox.outerHeight();
        // console.log("scrolledPast: %s, scrolltop: %d, siteheader outerheight: %d, ctaboxoffsettop: %d, ctabox outerheight: %d", 
        //     scrolledPast,
        //     $(document).scrollTop(), $('.siteHeader').outerHeight(), 
        //     this.ctaBox.offset().top, this.ctaBox.outerHeight());
        return scrolledPast;
    }

    sidebarFade() {
        if ($(window).outerWidth() < 768)
            return;

        // when scrolling down, once the cta box collides with the profile box, fade the profile box out
        // Do the same when scrolling up and the cta box is no longer on top of where the profile box would be.
        let sidebarBottom = $(document).scrollTop() + $('.siteHeader').height() + this.sidebar.outerHeight();
        if ($('#wpadminbar').length > 0)
            sidebarBottom += $('#wpadminbar').height();
        // console.log("sidebar bottom: %d, ctaboxoffsettop: %d, !cta box scrolled past: %s", sidebarBottom, this.ctaBox.offset().top, !this.ctaBoxScrolledPast());
        if ((sidebarBottom >= this.ctaBox.offset().top) && !this.ctaBoxScrolledPast()) {
            this.sidebar.addClass('fade');
        } else if (!this.ctaBoxScrolledPast()) {
            this.sidebar.removeClass('fade');
        }
    }

    onScroll(e) {
        if ($(window).outerWidth() > 767) {
            this.resizeSidebarItems();
            this.sidebarFade();
        }
    }
}